// src/services/projects.js
// Cada proyecto es un .md en src/projects/. Los que empiezan por "_" (como _plantilla.md) se ignoran.
import { parseFrontmatter } from './blog';

const modules = import.meta.glob('/src/projects/*.md', { as: 'raw', eager: true });

function toProject([filePath, raw]) {
  const file = filePath.split('/').pop();
  if (!raw || file.startsWith('_')) return null;
  const { meta, content } = parseFrontmatter(raw);
  const slug = file.replace(/\.md$/, '');
  return {
    slug,
    title: meta.title || slug,
    date: meta.date || '',
    summary: meta.summary || '',
    status: meta.status || '',
    tags: Array.isArray(meta.tags) ? meta.tags : [],
    cover: meta.cover || '',
    repo: meta.repo || '',
    demo: meta.demo || '',
    content,
  };
}

export function getAllProjects() {
  return Object.entries(modules)
    .map(toProject)
    .filter(Boolean)
    .sort((a, b) => b.date.localeCompare(a.date));
}

export function getProject(slug) {
  return getAllProjects().find((p) => p.slug === slug) || null;
}
